import React, { useState, useEffect } from 'react';

export default function PWAInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isIOS, setIsIOS] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    // Check if dismissed previously
    if (localStorage.getItem('pwa_prompt_dismissed')) {
      setDismissed(true);
    }

    // Check if running in standalone mode (already installed)
    if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) {
      setIsStandalone(true);
    }

    // Detect iOS Safari
    const ua = window.navigator.userAgent;
    const webkit = !!ua.match(/WebKit/i);
    const isIOSMobile = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    const isSafari = isIOSMobile && webkit && !ua.match(/CriOS/i) && !ua.match(/FxiOS/i);
    setIsIOS(isSafari);

    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  if (isStandalone || dismissed) return null;

  if (!deferredPrompt && !isIOS) return null;

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setDeferredPrompt(null);
    }
  };

  const handleDismiss = () => {
    setDismissed(true);
    localStorage.setItem('pwa_prompt_dismissed', 'true');
  };

  return (
    <div style={{
      position: 'fixed', bottom: '80px', left: '20px', right: '20px', maxWidth: '400px', margin: '0 auto',
      background: 'linear-gradient(135deg, #1e3a5f 0%, #152943 100%)', color: 'white',
      padding: '16px 20px', borderRadius: '16px', zIndex: 9999,
      boxShadow: '0 10px 25px rgba(0,0,0,0.2), 0 0 0 1px rgba(255,255,255,0.1)',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '16px',
      direction: 'rtl',
      animation: 'slideUp 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards'
    }}>
      <style>{`
        @keyframes slideUp {
          from { transform: translateY(100px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
      `}</style>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1 }}>
        <img src="/logo192.png" alt="Icon" style={{ width: 44, height: 44, borderRadius: 10, background: 'white', padding: 2 }} />
        <div>
          <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 2 }}>MIVIDA PENSION</div>
          <div style={{ fontSize: 12, opacity: 0.8, lineHeight: 1.2 }}>
            {isIOS ? 'התקן על מסך הבית לגישה מהירה' : 'התקן את האפליקציה למסך הבית'}
          </div>
        </div>
      </div>
      
      {isIOS ? (
        <div style={{ fontSize: 11, background: 'rgba(255,255,255,0.15)', padding: '8px 12px', borderRadius: 8, textAlign: 'center', minWidth: 90 }}>
          לחץ על <strong>כפתור השיתוף</strong> (מרובע עם חץ)<br/> ואז "Add to Home Screen"
        </div>
      ) : (
        <button onClick={handleInstallClick} style={{
          background: 'white', color: '#1e3a5f', border: 'none', padding: '8px 16px',
          borderRadius: '20px', fontWeight: 700, fontSize: 14, cursor: 'pointer',
          boxShadow: '0 4px 10px rgba(0,0,0,0.15)', transition: 'transform 0.2s',
        }}>
          התקן
        </button>
      )}
      <button onClick={handleDismiss} style={{
        position: 'absolute', top: -10, left: -10, background: '#ef4444', color: 'white',
        border: 'none', width: 24, height: 24, borderRadius: '50%', cursor: 'pointer',
        display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14,
        boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
      }}>
        ✕
      </button>
    </div>
  );
}
